// extracted by mini-css-extract-plugin
export default {"Currency--positive":"CurrencyFormatter_Currency--positive__NMsiB"};